import Operation from './Operation.js';
import AddEvent from './AddEvent.js';
import AddDeterministicEvent from './AddDeterministicEvent.js';

class InsertEvent extends Operation {
    constructor(mix, event, duration) {
        super(mix, event.getType());

        this.event = event;
        this.duration = duration;
    }

    addEvent(event, time, stepNumber) {
        if (event.isDeterministic()) {
            new AddDeterministicEvent(this.mix, event, time, stepNumber)
                .execute();
        } else {
            new AddEvent(this.mix, event, time, stepNumber)
                .execute();
        }
    }

    execute() {
        if (isNaN(this.event.step)) {
            return;
        }

        // first see if we are insert where a current pattern
        // overlaps
        for (let i in this.events) {
            let mixEvent = this.events[i];
            if (!mixEvent.isPrunable() &&
                mixEvent.duration !== undefined &&
                mixEvent.step < this.event.step &&
                mixEvent.step + mixEvent.duration >
                this.duration + this.event.step) {
                // then we must add an event at the end of event.step + duration
                let newEvent = mixEvent.getCopy(this.mix.sequencerEngine);
                newEvent.step = this.event.step;
                // newEvent.step = this.event.step + this.duration;
                this.addEvent(newEvent, 0, newEvent.step);
                return;
            }
        }

        this.addEvent(this.event, 0, this.event.step);
    }
}

export default InsertEvent;
